import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { MintRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Mint';
import { SUC_CAN_MINT, ERR_CAN_MINT } from '../../../../utils/strings';

export const useCancelMintRequest = () => {
  const { submit } = useExerciseSubmission(
    MintRequest.MintRequest_Cancel,
    SUC_CAN_MINT,
    ERR_CAN_MINT,
  );
  return submit;
};
